import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function ValueComparison() {
  return <section className="w-full bg-[#0E2238] py-20 px-4 sm:px-6 lg:px-8" data-id="element-259">
      <div className="max-w-7xl mx-auto" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-261">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6" data-id="element-262">
            Compara y{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-263">
              Decide Tú Mismo
            </span>
          </h2>
          <p className="text-xl text-[#F2F4F8]/80 max-w-3xl mx-auto" data-id="element-264">
            ¿Qué prefieres? ¿Seguir gastando o invertir en conocimiento real?
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-265">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#132A44] border-2 border-red-500/30 rounded-xl p-8" data-id="element-266">
            <div className="text-center mb-6" data-id="element-267">
              <div className="inline-block p-3 bg-red-500/20 rounded-full mb-4" data-id="element-268">
                <XIcon className="w-8 h-8 text-red-400" data-id="element-269" />
              </div>
              <h3 className="text-2xl font-bold text-[#F2F4F8] mb-2" data-id="element-270">
                Sin Este Manual
              </h3>
              <p className="text-red-400 font-semibold" data-id="element-271">
                Sigues perdiendo dinero
              </p>
            </div>

            <ul className="space-y-4" data-id="element-272">
              <li className="flex items-start gap-3" data-id="element-273">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-274" />
                <span className="text-[#F2F4F8]/80" data-id="element-275">
                  Gastas de más en creatinas "premium" por el mismo producto /
                  calidad
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-276">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-277" />
                <span className="text-[#F2F4F8]/80" data-id="element-278">
                  Compras "creatina" que no contiene creatina por comprar lo más
                  barato
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-279">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-280" />
                <span className="text-[#F2F4F8]/80" data-id="element-281">
                  Caes en marketing engañoso una y otra vez
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-282">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-283" />
                <span className="text-[#F2F4F8]/80" data-id="element-284">
                  Desperdicias minimo $100.000 al año comprando mal
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-285">
                <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-286" />
                <span className="text-[#F2F4F8]/80" data-id="element-287">
                  Nunca sabes si estás tomando de la manera correcta
                </span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#132A44] border-2 border-[#2F6BFF] rounded-xl p-8 relative" data-id="element-288">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-289">
              <span className="bg-[#2F6BFF] text-white px-6 py-2 rounded-full text-sm font-bold" data-id="element-290">
                MEJOR OPCIÓN
              </span>
            </div>

            <div className="text-center mb-6 mt-4" data-id="element-291">
              <div className="inline-block p-3 bg-[#2F6BFF]/20 rounded-full mb-4" data-id="element-292">
                <CheckIcon className="w-8 h-8 text-[#2F6BFF]" data-id="element-293" />
              </div>
              <h3 className="text-2xl font-bold text-[#F2F4F8] mb-2" data-id="element-294">
                Con Este Manual
              </h3>
              <p className="text-[#2F6BFF] font-semibold" data-id="element-295">
                Inviertes una vez, ahorras siempre
              </p>
            </div>

            <ul className="space-y-4" data-id="element-296">
              <li className="flex items-start gap-3" data-id="element-297">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-298" />
                <span className="text-[#F2F4F8]/80" data-id="element-299">
                  Sabes exactamente qué creatina comprar
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-300">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-301" />
                <span className="text-[#F2F4F8]/80" data-id="element-302">
                  Identificas productos de calidad vs. estafa
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-303">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-304" />
                <span className="text-[#F2F4F8]/80" data-id="element-305">
                  Sabes todo lo necesario sobre creatina con base científica
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-306">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-307" />
                <span className="text-[#F2F4F8]/80" data-id="element-308">
                  Ahorras miles al año en suplementos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-309">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-310" />
                <span className="text-[#F2F4F8]/80" data-id="element-311">
                  Obtienes los resultados esperados.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}